import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import { deserialize } from 'deserialize-json-api';
// utils
import axios from '../../../utils/axios';
import { dispatch } from '../../store';
dayjs.extend(weekday);

function getMondayAndSundayDates() {
  // Get the current date using dayjs
  const currentDate = dayjs();

  // Calculate Monday (set day to 1 for Monday)
  const monday = currentDate.weekday(1);

  // Calculate Sunday (set day to 7 for Sunday)
  const sunday = currentDate.weekday(7);

  // Convert dayjs objects to JavaScript Date objects
  const mondayDate = monday.toDate();
  const sundayDate = sunday.toDate();

  return { mondayDate, sundayDate };
}

const initialState = {
  1: {
    deliveries: [],
    isLoading: false,
    error: null,
    name: "Today's Deliveries",
    alternativeName: 'Today',
    startDate: new Date(),
    endDate: new Date(),
    columnId: 1,
  },
  2: {
    deliveries: [],
    isLoading: false,
    error: null,
    name: "Tomorrow's Deliveries",
    alternativeName: 'Tomorrow',
    startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    columnId: 2,
  },
  3: {
    deliveries: [],
    isLoading: false,
    error: null,
    alternativeName: 'this week',
    name: "This Week's Deliveries" /* Weekly Delivery Overview, 7-Day Delivery Plan, Deliveries for the Week */,
    startDate: getMondayAndSundayDates().mondayDate,
    endDate: getMondayAndSundayDates().sundayDate,
    columnId: 3,
  },
};

const slice = createSlice({
  name: 'Kanban HQ Deliveries',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Success Deliveries
    getDeliveriesSuccess(state, action) {
      const columnId = action.payload.columnId;
      const receivedData = action.payload.receivedData;
      state[columnId].deliveries = receivedData;
    },
    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },
  },
});

// reducers
export default slice.reducer;

// Actions
export const { getDeliveriesSccess } = slice.actions;

// columnId
// 1 - Today
// 2 - Tomorrow
// Todo change to using expected delivery date
export function getRetailerCustomers({ filterPickupDateFrom, filterPickupDateEnd, searchVal: searchVal, columnId }) {
  return async () => {
    try {
      let pathName = '/retailer_app/api/v1/retailers/hq/orders';
      if (searchVal != undefined && searchVal.trim()) {
        const fromDate = dayjs(filterPickupDateFrom).format('YYYY-MM-DD');
        const endDate = dayjs(filterPickupDateEnd).format('YYYY-MM-DD');
        pathName = `${pathName}?search_val=${searchVal}&start_date=${fromDate}&end_date=${endDate}`;
      } else {
        const fromDate = dayjs(filterPickupDateFrom).format('YYYY-MM-DD');
        const endDate = dayjs(filterPickupDateEnd).format('YYYY-MM-DD');
        pathName = `${pathName}?start_date=${fromDate}&end_date=${endDate}`;
      }
      const response = await axios.get(pathName);
      const payload = deserialize(response.data, { transformKeys: 'camelCase' }).data;
      const receivedData = formatData(payload);
      dispatch(slice.actions.getDeliveriesSuccess({ receivedData, columnId }));
    } catch (error) {
      console.error('Error fetching retailer customers:', error);
      throw error;
    }
  };
}

function formatData(data) {
  return data.map((datum) => {
    // status/ totalWeight / pickupDate /
    return {
      id: datum.customerId,
      retailer: 'Naivas',
      outletName: datum.name,
      totalPackages: datum.totalPackages, // This is a combination of delivered and pending packages
      expectedArrivalDate: datum.expectedArrivalDate,
      deliveredPackages: datum.deliveredPackages,
      pendingPackages: datum.pendingPackages,
      orderIds: datum.orderIds,
      completedDeliveries: datum.orderDetails.reduce(
        (accumulator, orderDetail) => (orderDetail.status === 'delivered' ? accumulator + 1 : accumulator),
        0
      ),
      ordersDetails: datum.orderDetails.map((orderDetail) => ({
        ...orderDetail,
        references: orderDetail.references.sort((a, b) => b.name.localeCompare(a.name)),
      })),
    };
  });
}
